import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { API, LingoApiResponse, Schemas } from "@thenounproject/lingo-core";
import * as actionTypes from "../actions/actionTypes";

const { CALL_API } = API;

export default () => {
  const dispatch = useDispatch();
  return useCallback(
    (collectionId: string) => {
      return dispatch(fetchKitCollection(collectionId)) as unknown as Promise<LingoApiResponse>;
    },
    [dispatch]
  );
};

export function fetchKitCollection(collectionId: string) {
  return {
    [CALL_API]: {
      types: [
        actionTypes.FETCH_KIT_COLLECTION,
        actionTypes.FETCH_KIT_COLLECTION_SUCCESS,
        actionTypes.FETCH_KIT_COLLECTION_FAILURE,
      ],
      endpoint: `/kit_collections/${collectionId}`,
      schema: Schemas.KIT_COLLECTION,
      method: "GET",
    },
  };
}
